import React, { type ReactNode } from 'react';

import { cssMap } from '@atlaskit/css';
import { Box, Stack } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	sectionContainer: {
		paddingInline: token('space.100'),
	},
	headingContainer: {
		display: 'flex',
		alignItems: 'center',
		justifyItems: 'center',
	},
	headingText: {
		font: token('font.body'),
		color: token('color.text.subtlest'),
		paddingLeft: token('space.200'),
		paddingRight: token('space.150'),
		paddingTop: token('space.150'),
		paddingBottom: token('space.050'),
	},
});

export const MenuSection = ({
	children,
	heading,
}: {
	children: ReactNode;
	heading: string;
}): React.JSX.Element => {
	return (
		<Stack alignInline="start" xcss={styles.sectionContainer}>
			<Box xcss={styles.headingContainer}>
				<Box xcss={styles.headingText}>{heading}</Box>
			</Box>
			{children}
		</Stack>
	);
};
